// @ts-ignore
import gateway from '@/gateway'

export const getDraftId = (cb) => {
  gateway.get('/cms/homepage')
    .then((response) => {
      cb(null, response.data)
    })
    .catch((err) => {
      cb(err, null)
    })
}

export const presentArticleData = (article) => {
  return article ? { article: {id: article.id, title: article.title} } : {article: null}
}

export const getBriefingThumbnail = (briefingUrl, cb) => {
  gateway.get(`/cms/homepage/briefing/${encodeURIComponent(briefingUrl)}`)
    .then((response) => {
      cb(null, response.data)
    })
    .catch((err) => {
      cb(err, null)
    })
}
